module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    staticClass: "col-md-4 offset-md-4 justify-content-center login",
    attrs: {
      "title": "Login"
    }
  }, [_c('form', [_c('b-form-input', {
    attrs: {
      "type": "text",
      "name": "login",
      "placeholder": "Enter your name"
    },
    model: {
      value: (_vm.data.username),
      callback: function($$v) {
        _vm.data.username = $$v
      },
      expression: "data.username"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Enter your password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.login($event)
      }
    },
    model: {
      value: (_vm.data.password),
      callback: function($$v) {
        _vm.data.password = $$v
      },
      expression: "data.password"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51aa0b2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 706
// module chunks = 1